import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { formatContaContabil } from "../../helpers/formaters";
import { StyleSheet } from "aphrodite";
import { Clear, Search } from "@mui/icons-material";
import { useEffect } from "react";

export const FilterConsAPagar = (props) => {
  const textFieldStyles = {
    marginTop: "0.5rem",
    "& .MuiInputBase-root": {
      height: "30px",
      fontSize: 12,
      backgroundColor: "inherit",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiInputBase-input": {
      height: "30px",
      boxSizing: "border-box",
      cursor: "text",
      fontSize: "12px",
      textAlign: "left",
      '&[type="date"]': {
        fontSize: "14px",
      },
      "&.Mui-readOnly": {
        fontSize: "12px",
        "-webkit-text-fill-color": "inherit",
      },
      "&::placeholder": {
        fontSize: "12px",
        opacity: 1,
        textAlign: "left",
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: 10,
      transform: "translate(10px, 6px) scale(1)",
      "& .MuiFormLabel-asterisk": {
        color: "red",
        fontWeight: "bold",
      },
    },
    "& .MuiInputLabel-shrink": {
      transform: "translate(10px, -8px) scale(0.75)",
    },
  };

  useEffect(() => {
    if (!props.situacaoPago) {
      props.setDataLiquidadoIni?.("");
      props.setDataLiquidadoFim?.("");
    }
  }, [props.situacaoPago]);

  const handleBancoChange = (idSelecionado) => {
    props.setBanco(idSelecionado);
    props.setAgencia("");
    props.setContaCorrente("");
  };

  return (
    <Paper sx={{ borderRadius: 1, overflow: "hidden" }} elevation={1}>
      <Box
        sx={{
          px: 2,
          py: 0.5,
          bgcolor: "#669966",
          color: "white",
          fontWeight: 600,
          fontSize: 14,
        }}
      >
        Filtros
      </Box>

      <Box sx={{ p: 1 }}>
        <Grid container spacing={1}>
          <Grid size={{ xs: 12 }}>
            <Grid container spacing={1} alignItems="flex-start">
              <Grid size={{ xs: 12, lg: 8.5 }}>
                <Grid container spacing={1}>
                  <Grid size={{ xs: 12 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      select
                      InputProps={{
                        endAdornment: props.fornecedor && (
                          <InputAdornment
                            position="end"
                            sx={{ marginRight: 2 }}
                          >
                            <IconButton
                              size="small"
                              onClick={() => props.setFornecedor("")} // Limpa o estado
                              edge="end"
                            >
                              <Clear sx={{ fontSize: 18 }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            sx: {
                              "& .MuiMenuItem-root": {
                                fontSize: "11px",
                                minHeight: "24px",
                                paddingTop: "2px",
                                paddingBottom: "2px",
                              },
                            },
                          },
                        },
                      }}
                      color="success"
                      label="Fornecedor"
                      size="small"
                      value={props.fornecedor}
                      onChange={(e) => props.setFornecedor(e.target.value)}
                    >
                      {props.fornecedorList?.map((fornecedor) => (
                        <MenuItem key={fornecedor.id} value={fornecedor.id}>
                          {fornecedor.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid size={{ xs: 12, md: 5 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      select
                      color="success"
                      label="Banco"
                      InputProps={{
                        endAdornment: props.banco && (
                          <InputAdornment
                            position="end"
                            sx={{ marginRight: 2 }}
                          >
                            <IconButton
                              size="small"
                              onClick={() => props.setBanco("")} // Limpa o estado
                              edge="end"
                            >
                              <Clear sx={{ fontSize: 18 }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            sx: {
                              "& .MuiMenuItem-root": {
                                fontSize: "11px",
                                minHeight: "24px",
                                paddingTop: "2px",
                                paddingBottom: "2px",
                              },
                            },
                          },
                        },
                      }}
                      size="small"
                      value={props.banco}
                      onChange={(e) => handleBancoChange(e.target.value)}
                    >
                      {props.contaCorrenteList?.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid size={{ xs: 12, md: 3.5 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      select
                      color="success"
                      label="Agência"
                      size="small"
                      InputProps={{
                        endAdornment: props.banco && (
                          <InputAdornment
                            position="end"
                            sx={{ marginRight: 2 }}
                          >
                            <IconButton
                              size="small"
                              onClick={() => props.setAgencia("")} // Limpa o estado
                              edge="end"
                            >
                              <Clear sx={{ fontSize: 18 }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            sx: {
                              "& .MuiMenuItem-root": {
                                fontSize: "11px",
                                minHeight: "24px",
                                paddingTop: "2px",
                                paddingBottom: "2px",
                              },
                            },
                          },
                        },
                      }}
                      value={props.agencia}
                      onChange={(e) => props.setAgencia(e.target.value)}
                      disabled={!props.banco}
                    >
                      {props.contaCorrenteList
                        ?.filter((item) => {
                          const bancoSelecionado = props.contaCorrenteList.find(
                            (b) => b.id === props.banco,
                          );
                          return item.name === bancoSelecionado?.name;
                        })
                        .map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.agencia}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>

                  <Grid size={{ xs: 12, md: 3.5 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      select
                      color="success"
                      InputProps={{
                        endAdornment: props.banco && (
                          <InputAdornment
                            position="end"
                            sx={{ marginRight: 2 }}
                          >
                            <IconButton
                              size="small"
                              onClick={() => props.setContaCorrente("")} // Limpa o estado
                              edge="end"
                            >
                              <Clear sx={{ fontSize: 18 }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            sx: {
                              "& .MuiMenuItem-root": {
                                fontSize: "11px",
                                minHeight: "24px",
                                paddingTop: "2px",
                                paddingBottom: "2px",
                              },
                            },
                          },
                        },
                      }}
                      label="Conta Corrente"
                      size="small"
                      value={props.contaCorrente}
                      onChange={(e) => props.setContaCorrente?.(e.target.value)}
                      disabled={!props.banco}
                    >
                      {props.contaCorrenteList
                        ?.filter((item) => {
                          const bancoSelecionado = props.contaCorrenteList.find(
                            (b) => b.id === props.banco,
                          );
                          return item.name === bancoSelecionado?.name;
                        })
                        .map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.conta}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>

                  <Grid size={{ xs: 12, md: 2.5 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      color="success"
                      label="Nº Documento"
                      size="small"
                      InputProps={{
                        endAdornment: props.numDoc && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => props.setNumDoc("")} // Limpa o estado
                              edge="end"
                            >
                              <Clear sx={{ fontSize: 18 }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      value={props.numDoc}
                      onChange={(e) => props.setNumDoc?.(e.target.value)}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 4.75 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      select
                      InputProps={{
                        endAdornment: props.centroCusto && (
                          <InputAdornment
                            position="end"
                            sx={{ marginRight: 2 }}
                          >
                            <IconButton
                              size="small"
                              onClick={() => props.setCentroCusto("")} // Limpa o estado
                              edge="end"
                            >
                              <Clear sx={{ fontSize: 18 }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            sx: {
                              "& .MuiMenuItem-root": {
                                fontSize: "11px",
                                minHeight: "24px",
                                paddingTop: "2px",
                                paddingBottom: "2px",
                              },
                            },
                          },
                        },
                      }}
                      color="success"
                      label="Centro de Custos"
                      size="small"
                      value={props.centroCusto}
                      onChange={(e) => props.handleChangeCentroCusto(e)}
                    >
                      {props.centroCustoList?.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid size={{ xs: 12, md: 4.75 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      select
                      InputProps={{
                        endAdornment: props.despesa && (
                          <InputAdornment
                            position="end"
                            sx={{ marginRight: 2 }}
                          >
                            <IconButton
                              size="small"
                              onClick={() => props.setDespesa("")} // Limpa o estado
                              edge="end"
                            >
                              <Clear sx={{ fontSize: 18 }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            sx: {
                              "& .MuiMenuItem-root": {
                                fontSize: "11px",
                                minHeight: "24px",
                                paddingTop: "2px",
                                paddingBottom: "2px",
                              },
                            },
                          },
                        },
                      }}
                      color="success"
                      label="Despesa"
                      size="small"
                      value={props.despesa}
                      onChange={(e) => props.handleChangeDespesa(e)}
                    >
                      {props.despesaList?.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid size={{ xs: 12 }}>
                    <TextField
                      sx={textFieldStyles}
                      fullWidth
                      select
                      InputProps={{
                        endAdornment: props.planoContas && (
                          <InputAdornment
                            position="end"
                            sx={{ marginRight: 2 }}
                          >
                            <IconButton
                              size="small"
                              onClick={() => props.setPlanoContas("")} // Limpa o estado
                              edge="end"
                            >
                              <Clear sx={{ fontSize: 18 }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            sx: {
                              "& .MuiMenuItem-root": {
                                fontSize: "11px",
                                minHeight: "24px",
                                paddingTop: "2px",
                                paddingBottom: "2px",
                              },
                            },
                          },
                        },
                      }}
                      color="success"
                      label="Conta Contábil"
                      size="small"
                      value={props.planoContas}
                      onChange={(e) => props.setPlanoContas?.(e.target.value)}
                    >
                      {props.planoContasList?.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.id} - {item.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid size={{ xs: 12 }}>
                    <Paper
                      variant="outlined"
                      sx={{
                        borderRadius: 1,
                        borderColor: "divider",
                        p: 0.75,
                      }}
                    >
                      <Grid container spacing={1} alignItems="flex-end">
                        <Grid size={{ xs: 12, md: 6 }}>
                          <Typography
                            sx={{
                              fontSize: 11,
                              color: "text.secondary",
                              mb: 0.25,
                            }}
                          >
                            Emissão
                          </Typography>
                          <Grid container spacing={1}>
                            <Grid size={{ xs: 6 }}>
                              <TextField
                                sx={textFieldStyles}
                                type="date"
                                size="small"
                                color="success"
                                fullWidth
                                value={props.dataEmissaoIni}
                                onChange={(e) =>
                                  props.setDataEmissaoIni?.(e.target.value)
                                }
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            <Grid size={{ xs: 6 }}>
                              <TextField
                                sx={textFieldStyles}
                                type="date"
                                size="small"
                                color="success"
                                fullWidth
                                value={props.dataEmissaoFim}
                                onChange={(e) =>
                                  props.setDataEmissaoFim?.(e.target.value)
                                }
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                          <Typography
                            sx={{
                              fontSize: 11,
                              color: "text.secondary",
                              mb: 0.25,
                            }}
                          >
                            Previsão
                          </Typography>
                          <Grid container spacing={1}>
                            <Grid size={{ xs: 6 }}>
                              <TextField
                                sx={textFieldStyles}
                                type="date"
                                size="small"
                                color="success"
                                fullWidth
                                value={props.dataPrevisaoIni}
                                onChange={(e) =>
                                  props.setDataPrevisaoIni?.(e.target.value)
                                }
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            <Grid size={{ xs: 6 }}>
                              <TextField
                                sx={textFieldStyles}
                                type="date"
                                size="small"
                                color="success"
                                fullWidth
                                value={props.dataPrevisaoFim}
                                onChange={(e) =>
                                  props.setDataPrevisaoFim?.(e.target.value)
                                }
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                          <Typography
                            sx={{
                              fontSize: 11,
                              color: "text.secondary",
                              mb: 0.25,
                            }}
                          >
                            Vencimento
                          </Typography>
                          <Grid container spacing={1}>
                            <Grid size={{ xs: 6 }}>
                              <TextField
                                sx={textFieldStyles}
                                type="date"
                                size="small"
                                color="success"
                                fullWidth
                                value={props.dataVencimentoIni}
                                onChange={(e) =>
                                  props.setDataVencimentoIni?.(e.target.value)
                                }
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            <Grid size={{ xs: 6 }}>
                              <TextField
                                sx={textFieldStyles}
                                type="date"
                                size="small"
                                color="success"
                                fullWidth
                                value={props.dataVencimentoFim}
                                onChange={(e) =>
                                  props.setDataVencimentoFim?.(e.target.value)
                                }
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        {props.situacaoPago && (
                          <Grid size={{ xs: 12, md: 6 }}>
                            <Box
                              sx={{
                                mt: 0.75,
                                pt: 0.75,
                                borderColor: "divider",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: 11,
                                  color: "text.secondary",
                                  mb: 0.25,
                                }}
                              >
                                Liquidado
                              </Typography>

                              <Grid container spacing={1}>
                                <Grid size={{ xs: 6, md: 6 }}>
                                  <TextField
                                    sx={textFieldStyles}
                                    type="date"
                                    size="small"
                                    color="success"
                                    fullWidth
                                    value={props.dataLiquidadoIni}
                                    onChange={(e) =>
                                      props.setDataLiquidadoIni?.(
                                        e.target.value,
                                      )
                                    }
                                    InputLabelProps={{ shrink: true }}
                                  />
                                </Grid>
                                <Grid size={{ xs: 6, md: 6 }}>
                                  <TextField
                                    sx={textFieldStyles}
                                    type="date"
                                    size="small"
                                    color="success"
                                    fullWidth
                                    value={props.dataLiquidadoFim}
                                    onChange={(e) =>
                                      props.setDataLiquidadoFim?.(
                                        e.target.value,
                                      )
                                    }
                                    InputLabelProps={{ shrink: true }}
                                  />
                                </Grid>
                              </Grid>
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    </Paper>

                    <Grid
                      size={{ xs: 12 }}
                      sx={{
                        display: { xs: "none", lg: "flex" },
                        justifyContent: "flex-end",
                        flexDirection: { md: "column", lg: "row" },
                        gap: 1,
                        mt: 1,
                      }}
                    >
                      <Button
                        variant="contained"
                        color="success"
                        onClick={() => props.consultar()}
                        sx={{ minWidth: 120, fontSize: 12, bgcolor: "#669966" }}
                        title="Consulta"
                      >
                        <Search />
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid size={{ xs: 12, lg: 3.5 }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <Box
                    component="fieldset"
                    sx={{
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 1,
                      px: 1,
                      pt: 0.75,
                      pb: 0.5,
                    }}
                  >
                    <Box
                      component="legend"
                      sx={{ fontSize: 11, color: "text.secondary", px: 0.5 }}
                    >
                      Situação
                    </Box>

                    <FormGroup row sx={{ justifyContent: "space-between" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            color="success"
                            checked={props.situacaoAberto}
                            onChange={(e) =>
                              props.setSituacaoAberto?.(e.target.checked)
                            }
                          />
                        }
                        label="Aberto"
                        sx={{
                          "& .MuiFormControlLabel-label": { fontSize: 12 },
                        }}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            color="success"
                            checked={props.situacaoPago}
                            onChange={(e) =>
                              props.setSituacaoPago?.(e.target.checked)
                            }
                          />
                        }
                        label="Pago"
                        sx={{
                          "& .MuiFormControlLabel-label": { fontSize: 12 },
                        }}
                      />
                    </FormGroup>
                  </Box>

                  <Box
                    component="fieldset"
                    sx={{
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 1,
                      px: 1,
                      pt: 0.75,
                      pb: 0.5,
                    }}
                  >
                    <Box
                      component="legend"
                      sx={{ fontSize: 11, color: "text.secondary", px: 0.5 }}
                    >
                      Todos os Docto.
                    </Box>

                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          color="success"
                          checked={props.todosDocto}
                          onChange={(e) =>
                            props.setTodosDocto?.(e.target.checked)
                          }
                        />
                      }
                      label="Selecionar Todos"
                      sx={{
                        m: 0,
                        "& .MuiFormControlLabel-label": { fontSize: 12 },
                      }}
                    />

                    <Box
                      sx={{
                        mt: 0.5,
                        maxHeight: 80,
                        overflowY: "auto",
                        borderTop: "1px solid",
                        borderColor: "divider",
                        pt: 0.5,
                      }}
                    >
                      {(props.doctosList ?? []).map((d) => (
                        <Grid key={d.id} size={{ xs: 6 }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                color="success"
                                checked={!!d.checked}
                                onChange={(e) =>
                                  props.onToggleDocto?.(d.id, e.target.checked)
                                }
                              />
                            }
                            label={d.name}
                            sx={{
                              m: 0,
                              "& .MuiFormControlLabel-label": {
                                fontSize: 12,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              },
                            }}
                          />
                        </Grid>
                      ))}
                    </Box>
                  </Box>

                  <Box
                    component="fieldset"
                    sx={{
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 1,
                      px: 1,
                      pt: 0.75,
                      pb: 0.5,
                    }}
                  >
                    <Box
                      component="legend"
                      sx={{ fontSize: 11, color: "text.secondary", px: 0.5 }}
                    >
                      Todos os estab.
                    </Box>

                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          color="success"
                          checked={props.todosEstab}
                          onChange={(e) =>
                            props.setTodosEstab?.(e.target.checked)
                          }
                        />
                      }
                      label="Selecionar Todos"
                      sx={{
                        m: 0,
                        "& .MuiFormControlLabel-label": { fontSize: 12 },
                      }}
                    />

                    <Box
                      sx={{
                        mt: 0.5,
                        maxHeight: 80,
                        overflowY: "auto",
                        borderTop: "1px solid",
                        borderColor: "divider",
                        pt: 0.5,
                      }}
                    >
                      {(props.estabsList ?? []).map((e) => (
                        <Grid key={e.id} size={{ xs: 12 }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                color="success"
                                checked={!!e.checked}
                                onChange={(ev) =>
                                  props.onToggleEstab?.(e.id, ev.target.checked)
                                }
                              />
                            }
                            label={e.name}
                            sx={{
                              m: 0,
                              "& .MuiFormControlLabel-label": {
                                fontSize: 12,
                              },
                            }}
                          />
                        </Grid>
                      ))}
                    </Box>
                  </Box>
                  <Grid
                    size={{ xs: 12 }}
                    sx={{
                      display: { xs: "flex", lg: "none" },
                      justifyContent: "flex-end",
                      flexDirection: { md: "column", lg: "row" },
                      gap: 1,
                      mt: 1,
                    }}
                  >
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => props.consultar()}
                      sx={{ minWidth: 120, fontSize: 12, bgcolor: "#669966" }}
                      title="Consulta"
                    >
                      <Search />
                    </Button>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

const styles = StyleSheet.create({
  input: {
    fontFamily: "Poppins !important",
    fontSize: 12,
    fontWeight: 400,
    color: "#808080",
    transitionDuration: "0.2s",
  },
  btn: {
    backgroundColor: "#669966",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#669966",
    borderRadius: 6,
    display: "flex !important",
    justifyContent: "center !important",
    alignContent: "center !important",
    padding: 0,
    width: "100%",
    height: 30,
    transitionDuration: "0.2s",
    ":hover": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
    },
    ":active": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
      opacity: 0.6,
    },
  },
  btnDisabled: {
    backgroundColor: "#B3B3B3",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#B3B3B3",
    borderRadius: 6,

    display: "flex !important",
    justifyContent: "center !important",
    alignContent: "center !important",
    padding: 0,
    width: "100%",
    height: 34,
  },
  erro: {
    // fontFamily: "Poppins",
    fontSize: 14,
    color: "red",
    textAlign: "center",
    fontWeight: 600,
    marginTop: "1rem",
    marginBottom: "-0.5rem",
  },
});
